"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CaretArrow = function CaretArrow() {
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, _react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("path", {
    d: "M24 0H0v24h24z"
  }), _react.default.createElement("path", {
    fill: "#113B5E",
    d: "M13.293 5.293a1 1 0 0 0 0 1.414L17.586 11H4a1 1 0 0 0-.993.883L3 12a1 1 0 0 0 1 1h13.586l-4.293 4.293a1 1 0 0 0 1.414 1.414l6-6 .073-.082.007-.008-.08.09a1.008 1.008 0 0 0 .282-.559A.997.997 0 0 0 21 12l-.004.09.004-.07V12a1.02 1.02 0 0 0-.125-.484.878.878 0 0 0-.088-.133 1.016 1.016 0 0 0-.08-.09l-6-6a1 1 0 0 0-1.414 0z"
  })));
};

var _default = CaretArrow;
exports.default = _default;
